<arb-base-dialog [title]="data.title" [subtitle]="data.subtitle">
  <ng-container actions>
    <button [class.thin]="data.thinButtons" (click)="close(false)" class="action-btn" [color]="data.rejectButtonColor"
            mat-flat-button>{{data.rejectButtonText}}
    </button>
    <button [class.thin]="data.thinButtons" (click)="close(true)" class="action-btn accept" mat-flat-button [color]="data.acceptButtonColor">
      {{ data.acceptButtonText }}
    </button>
    <button *ngIf="data.optionalBtn" [class.thin]="data.thinButtons" (click)="close('createprofile')" class="action-btn accept" mat-flat-button [color]="data.acceptButtonColor">
      {{ data.optionalButtonText }}
    </button>
  </ng-container>
</arb-base-dialog>